import type { Location } from '../../types';

// Room-level locations at the Andaz haven't been announced, so sessions point at
// the venue as a whole. Off-site dinner venues are still to be confirmed.
export const locations: Location[] = [
  {
    id: 'andaz',
    name: 'Andaz Miami Beach',
    address: '4041 Collins Avenue, Miami Beach, FL 33140',
  },
  {
    id: 'dinner',
    name: 'Location to be announced',
    building: 'Miami Beach, FL',
  },
];
